import React, {
  Component
} from 'react'

import PropTypes from 'prop-types'
import isEmail from 'validator/lib/isEmail'
import Axios from 'axios'


class NewsletterPush extends Component {
  constructor(props) {
    super(props)

    this.state = {}
    this.els = {}

    this.submitted = false
    this.inputBlurred = false
    this.checkboxBlurred = false

    this.onSubmit = this.onSubmit.bind(this);
  }

  componentDidMount() {
    this.els = {
      emailContainer: this.props.proxy.querySelector('.newsletter-input-container'),
      legalContainer: this.props.proxy.querySelector('.conditions'),
      emailField: this.props.proxy.querySelector('[name="newsletter-email"]'),
      legalField: this.props.proxy.querySelector('[name="cb"]'),
      form: this.props.proxy.querySelector('form'),
      button: this.props.proxy.querySelector('.send button')
    }

    this.els.form.addEventListener('submit', this.onSubmit)
    this.els.button.addEventListener('click', this.onSubmit)
    this.els.emailField.addEventListener('blur', () => {
      this.inputBlurred = true
      this.valid
    })
    this.els.emailField.addEventListener('input', () => this.valid)
    this.els.legalField.addEventListener('change', () => {
      this.checkboxBlurred = true;
      this.valid
    })
  }

  onSubmit(e) {
    e.preventDefault();
    this.submitted = true;

    if (!this.valid)
      return;

    this.pending = true;

    Axios.post('/api/newsletter', {email: this.emailFieldValue}).then((rs) => {
      this.props.proxy.classList.add("success");
    }, (err) => {
      console.log('is error', err);
      this.pending = false;
    })

  }

  set pending(val) {
    this.els.button.classList.remove('pending');
    if (val)
      this.els.button.classList.add('pending');
  }

  get emailFieldValue() {
    return this.els.emailField.value
  }

  get legalFieldValue() {
    return this.els.legalField.checked
  }

  get valid() {
    let emailValid = isEmail(this.emailFieldValue)
    let checkboxValid = this.legalFieldValue

    this.els.emailContainer.classList.remove('has-error')
    this.els.emailContainer.classList.remove('has-error-required')
    this.els.emailContainer.classList.remove('has-error-invalid')

    this.els.legalContainer.classList.remove('has-error')
    this.els.legalContainer.classList.remove('has-error-required')

    if ((!this.emailFieldValue || !emailValid) && (this.submitted || this.inputBlurred))
      this.els.emailContainer.classList.add('has-error')

    if (!this.emailFieldValue)
      this.els.emailContainer.classList.add('has-error-required')
    else if (!emailValid)
      this.els.emailContainer.classList.add('has-error-invalid')

    if (!checkboxValid && (this.submitted || this.checkboxBlurred)) {
      this.els.legalContainer.classList.add('has-error')
      this.els.legalContainer.classList.add('has-error-required')
    }

    return emailValid && checkboxValid;
  }

  render() {
    return <div></div>
  }
}

NewsletterPush.propTypes = {
  mobile: PropTypes.string,
  tablet: PropTypes.string,
  desktop: PropTypes.string,
  maxshow: PropTypes.string,
}

export default (NewsletterPush)


// WEBPACK FOOTER //
// ./resources/assets/frontend/js/components/NewsletterPush.js